module.exports = "/reports/directives/shiftFeedbackReportColumn-3f8fe7.html";